<template>
  <div id="app">
    <carousels :a='a'></carousels>
    <transition name="slide-fade">
    <router-view @pusha="geta"></router-view>
    </transition>
    <footer-view></footer-view>
  </div>

</template>





<script>
import Carousels from './components/Carousel';
import FooterView from "./components/FooterView.vue";
export default {
  name: "app",
  components: {
    Carousels,
    FooterView,
  },
   data () {
    return {
        a:[]
    }
  },
  
  methods:{
    geta(a){
      let vm= this;
      vm.a=a;
    }
  }
 
};
</script>

<style lang="css">

</style>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";

img {
  max-width: 100%;
}
#app {
  font-family: Microsoft JhengHei, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
<style lang="sass">
.page-item.active .page-link
  z-index: 1
  color: #fff !important
  background-color: rgb(182, 40, 44) !important
  border-color: rgb(182, 40, 44) !important
  box-shadow: none
.page-link 
  position: relative
  display: block
  margin-left: -1px
  line-height: 1.25
  color: black !important
  background-color: #fff
.page-link
  span
    pointer-events: none
.slide-fade-enter-active
  transition: all .5s ease
.slide-fade-leave-active
  transition: all .5s ease
.slide-fade-enter,.slide-fade-leave
  transform: translateX(-430px)
  opacity: 0

  
</style>



// WEBPACK FOOTER //
// src/App.vue